import { Helmet } from 'react-helmet'
import React from 'react'
import { FlexContainer } from 'components'
import history from 'configureHistory'

import './auth.scss'

const AuthLayout = ({ children }) => {
	document.body.classList.remove('theme--light', 'theme--dark')

	document.body.classList.add('theme--light')
	document.body.classList.add('scheme--default')

	document.getElementsByClassName('c-loading')[0].classList.add('is-finished')

	return (
		<div className="c-auth">
			<Helmet>
				<title>
					Skara - The first company wiki that your team will use in
					the long run.
				</title>
			</Helmet>
			<div className="c-auth__form">
				<FlexContainer withPadding>
					<a
						href="#"
						onClick={e => {
							e.preventDefault()
							history.push('/')
						}}
					>
						<img src="/assets/img/logo-beta.svg" alt="Skara" />
					</a>
				</FlexContainer>
				{children}
			</div>
			<div className="c-auth__promotion">
				<div className="c-auth__promotion-inner">
					<img src="/assets/img/register.svg" alt="" />
				</div>
			</div>
		</div>
	)
}

export default AuthLayout
